export const PUBLIC_KEY_V3 = import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY;
export const PUBLIC_KEY_V2 = import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY;
